import { CustomerBrowserData, PaymentSolutionDetails } from "@up/data";
import { BaseDto } from "./base.dto";

export class BillingPaymentMethodDto extends BaseDto {
  merchantGroupId: number;
  businessEntityId: number;
  paymentMethodId: number;
  token?: string;
  data?: PaymentSolutionDetails;
  customerBrowserData?: CustomerBrowserData;
  isDefault?: boolean;
}